import { DONOR_CHECKRECORDS, MEDICAL_TEMPLATE } from "../../actions/medicalTemplate"

const initState = {
  medicalTemplateData: false,
  medicalTemplateStepData: false,
  donorCheckRecords: null
}

export const medicalTemplateDataReducer = (state = initState, action = {}) => {
  switch (action.type) {
    case MEDICAL_TEMPLATE:
      return { ...state, ...action }
    case DONOR_CHECKRECORDS:
      return { 
        ...state,
        donorCheckRecords: action.payload }
    default:
      return state
  }
}
